import { useMemo } from "react";
import { useGoalDetailQuery } from "web_myplann/Api/Goals/useGoalDetailQuery";
import { formatDueIn } from "web_myplann/Goals/Helpers/formatDueIn";
import { mapToGoalDetailDto } from "web_myplann/Goals/Mappers/mapToGoalDetailDto";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import type { GoalDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

type UseGoalDetailResult = {
	goal: GoalDetail | undefined;
	dto: GoalDetailResponseDTO | undefined;
	isLoading: boolean;
	isNotFound: boolean;
};

export const useGoalDetail = (goalId: number | null): UseGoalDetailResult => {
	const { t } = useResource();
	const { data: goal, isLoading } = useGoalDetailQuery(goalId);

	const merged = useMemo<GoalDetail | undefined>(() => {
		if (!goal || goalId === null) return undefined;

		return mapToGoalDetailDto({
			id: String(goalId),
			dto: goal,
			dueIn: formatDueIn(goal.targetDate, t),
		});
	}, [goalId, goal, t]);

	return {
		goal: merged,
		dto: goal ?? undefined,
		isLoading,
		isNotFound: goal === null,
	};
};
